import styles from './GuideFooter.module.css';

interface GuideFooterProps {
  /** e.g. "FY27 guide, export 28 Jul 2026" — the ruleset's own label. */
  guideLabel: string;
  /** e.g. "1 Jul 2026 – 30 Jun 2027". */
  guideTerm: string;
}

/**
 * Provenance and scope disclaimer, reproduced from the guide's footer.
 *
 * The two sentences that matter most: Partner Center governs where it and this
 * tool disagree, and this tool cannot see claim history — so the portfolio-level
 * limits in ClaimConstraints are listed rather than tested. Both are the reason
 * a consultant is expected to verify before nominating, and removing them
 * changes what the output implies about its own authority.
 */
export function GuideFooter({ guideLabel, guideTerm }: GuideFooterProps): React.JSX.Element {
  return (
    <footer className={styles.foot}>
      <p className={styles.prose}>
        Built from the Microsoft Commercial Partner Incentives Guide &mdash; {guideLabel}, term{' '}
        {guideTerm}. The guide is Microsoft Confidential and subject to change; changes take
        prospective effect only. Verify t-shirt band and eligibility in Partner Center before
        nominating — <b>where this tool and Partner Center disagree, Partner Center governs</b>. This
        tool cannot see your claim history, so portfolio-level ratio and success-rate limits are
        listed but not calculated. Contract value for seat-based engagements uses the sell price you
        enter; the guide contains no pricing.
      </p>
      <div className={styles.credit}>
        <span>
          Exigo Tech Pty Ltd &middot; ABN 47 607 270 313 &middot; Sydney &middot; Melbourne &middot;
          Brisbane &middot; Auckland &middot; Singapore &middot; Manila
        </span>
        <span className={styles.stamp}>{guideLabel} &middot; verify in Partner Center before nominating</span>
      </div>
    </footer>
  );
}
